import TariffSeance from './tariff-seance';
import { ITranslatable } from '../Localization';
import { WpCorePrefixes } from '..';
import { TariffType } from './tariff-type';

export default class Tariff {
    Id: number = 0;
    TariffCode: number = 0;
    Name: string = '';
    OptionId: string = '';
    OptionName: string = '';
    GroupId?: number;
    GroupName: string = '';
    Category: string = '';
    WorkingDays: string = '';
    Description: string = '';
    Quota?: number;
    CalendarEnabled: boolean = true;
    StartSale: string = '';
    EndSale: string = '';
    ZIndex: number = 0;
    RequiredPersonification: boolean = false;
    IsRewritable: boolean = true;
    TariffType: TariffType = TariffType.Default;

    Seances: Array<TariffSeance> = [];
    ShowLeftTicketCount: boolean = false;
    HaveSeance: boolean = false;
}